import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { useT } from "../lib/i18n";

export const Showroom = () => {
  const { show: s } = useT();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section id="showroom" ref={ref} className="py-20 md:py-32" data-testid="showroom-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 lg:order-2">
          <Reveal>
            <Eyebrow>{s.eyebrow}</Eyebrow>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[0.95]">
              {s.t1} <span className="font-serif-i font-normal text-[var(--red)]">{s.em}</span>
            </h2>
            <p className="mt-8 text-[var(--ink-2)] leading-relaxed text-base md:text-lg">{s.txt}</p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-px bg-[var(--line)] rounded-2xl overflow-hidden border border-[var(--line)]">
            {[["EU", s.stat1], ["100%", s.stat2]].map(([n, l]) => (
              <div key={l} className="bg-[var(--bone)] p-6">
                <p className="font-display text-4xl font-semibold tracking-tight">{n}</p>
                <p className="mt-1 text-sm text-[var(--muted)]">{l}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7 lg:order-1 grid grid-cols-5 gap-4">
          <div className="col-span-3 relative aspect-[3/4] overflow-hidden rounded-[28px] bg-[var(--ink)]">
            <motion.img src="/img/showroom.jpg" alt="Auto sportive in showroom" style={{ y, scale: 1.25 }} className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="col-span-2 flex flex-col gap-4 pt-16">
            <div className="relative aspect-square overflow-hidden rounded-[24px] bg-[var(--ink)]">
              <img src="/img/coupe.jpg" alt="Coupé bianca" className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] bg-[var(--ink)]">
              <img src="/img/suv.jpg" alt="SUV di lusso" className="absolute inset-0 w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
